import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-control-panel',
  templateUrl: './config-panel.component.html',
  styleUrls: ['./config-panel.component.scss']
})
export class ConfigPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
